<template>
	<div id="app">
		<div class="topBar">
			<Header></Header>
		</div>
		<div class="main">
			<!-- keep-alive 是Vue的内置组件，能在组件切换过程中将状态保留在内存中，防止重复渲染DOM -->
			<!-- <keep-alive> -->
			<router-view></router-view>
			<!-- </keep-alive> -->
		</div>
		<div id="footer">
			<foot></foot>
		</div>
		<!-- 返回顶部 -->
		<div class="backTop" @click="toTop" id="backTop">
			<i class="el-icon-top"></i>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/Header";
	import foot from "@/components/foot";
	export default {
		components: {
			Header,
			foot
		},
		data() {
			return {

			};
		},

		mounted() {
			// 控制返回顶部显示
			window.addEventListener("scroll", this.scrollToTop);
		},
		//离开该页面需要移除这个监听的事件，不然会报错;
		destroyed() {
			window.removeEventListener("scroll", this.scrollToTop);
		},
		methods: {
			// 返回顶部显示
			scrollToTop() {
				let topBtn = document.getElementById("backTop");
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				// let browserHeight = window.outerHeight;
				// if (scrollTop > browserHeight - 100) {
				if (scrollTop > 150) {
					topBtn.style.display = "block";
				} else {
					topBtn.style.display = "none";
				}
			},
			// 带动画返回到顶部
			toTop() {
				// document.documentElement.scrollTop = 0;
				let top = document.documentElement.scrollTop || document.body.scrollTop
				// 实现滚动效果
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50
					if (top <= 0) {
						clearInterval(timeTop)
					}
				}, 10)
			},
		},
	};
</script>

<style scoped>
	.main,
	#footer {
		width: 100%;
	}

	.topBar {
		width: 100%;
		margin: 0 auto;
		margin-bottom: 60px;
	}

	.main {}

	#footer {
		height: 60px !important;
		line-height: 60px;
		background: #282f3c;
		/* position: fixed; */
		/* bottom: 0px; */
	}

	/* 返回顶部 */
	/* 样式1 */
	/* 	.backTop {
		position: fixed;
		bottom: 8%;
		right: 1%;
		width: 42px;
		height: 42px;
		border-radius: 6px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
		background: #282f3c;
		color: #fff;
		line-height: 42px;
		text-align: center;
		font-size: 26px;
		cursor: pointer;
		display: none;
	} */
	/* 样式2 */
	.backTop {
		position: fixed;
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border-radius: 50%;
		color: #409eff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		box-shadow: 0 0 6px rgb(0 0 0 / 12%);
		cursor: pointer;
		z-index: 5;
		/* right: 100px;
		bottom: 150px; */
		/* right: 100px; */
		right: 50px;
		bottom: 120px;
		display: none;
	}

	.backTop i {
		font-weight: bold;
	}
</style>